module.exports = __webpack_public_path__ + "static/media/4.d28276e8.jpg";